// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"178314a4","977":"2a2dca8d"}[chunkId] + ".chunk.js";
};